var exports = {
  "X": "BetaLabel__35gD5g",
};

module.exports = exports;
